import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { ExternalLink } from "lucide-react";

export const SetupGuides = ({ tools }) => {
  return (
    <div className="bg-card border border-border rounded-2xl p-6 md:p-8 shadow-sm">
      <h3 className="font-heading text-xl font-semibold mb-1">Guías de configuración paso a paso</h3>
      <p className="text-sm text-muted-foreground mb-6">
        Instrucciones en lenguaje sencillo. No necesitas saber de tecnología.
      </p>
      <Accordion type="single" collapsible className="w-full">
        {tools.map((tool, i) => (
          <AccordionItem key={tool.name} value={`item-${i}`} data-testid={`setup-guide-${i}`}>
            <AccordionTrigger className="text-left font-heading font-medium">
              Cómo configurar {tool.name}
            </AccordionTrigger>
            <AccordionContent>
              <ol className="space-y-3 pt-1">
                {tool.steps.map((step, si) => (
                  <li key={si} className="flex gap-3 text-sm text-muted-foreground">
                    <span className="h-6 w-6 shrink-0 rounded-full bg-secondary text-primary font-semibold flex items-center justify-center text-xs">
                      {si + 1}
                    </span>
                    <span className="leading-relaxed">{step}</span>
                  </li>
                ))}
              </ol>
              <a
                href={tool.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`setup-guide-link-${i}`}
                className="inline-flex items-center gap-1.5 text-sm font-semibold text-accent mt-4 hover:underline"
              >
                Empezar con {tool.provider} <ExternalLink className="h-3.5 w-3.5" />
              </a>
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
};
